import React from "react";
import FaEnvelope from "react-icons/fa/envelope";
import FaIntegration from "react-icons/fa/exchange";
import FaEmail from "react-icons/fa/at";
import FaUpload from "react-icons/fa/cloud-upload";
import FaUnknown from "react-icons/fa/question";
import styles from "components/grid/cell-formatters/upload-source-cell-formatter.scss";
import { uploadType } from "custom-prop-types";

export const UploadSourceCellFormatter = ({ value }) => {
  const { source, tooltip } = getSourceValue(value);
  return (
    <div className={ styles.container }>
      {source}
      <div className={ styles.tooltip } style={ { left: ((-tooltip.length * 4) - 20) } }>{tooltip}</div>
    </div>
  );
};

UploadSourceCellFormatter.propTypes = {
  value: uploadType.isRequired
};

const getSourceValue = (value) => {
  switch (value.type) {
    case "mail":
      return { source: <FaEnvelope size={ 15 } />, tooltip: "Envelope" };
    case "integration":
      return { source: <FaIntegration size={ 15 } />, tooltip: "Integration" };
    case "email":
      return { source: <FaEmail size={ 15 } />, tooltip: "Email" };
    case "web":
      return { source: <FaUpload size={ 15 } />, tooltip: "Web Upload" };
    case "unknown":
    default:
      return { source: <FaUnknown size={ 15 } />, tooltip: "Unknown" };
  }
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/upload-source-cell-formatter.jsx